import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './components/slider/slider.component';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SliderComponent],
  imports: [CommonModule, FormsModule, MatSliderModule],
  exports: [SliderComponent],
})
export class SliderModule {}
